import { SingleLineAddress } from '@/components/Address'
import { formatDate, formatSurface } from '@/utils/formatters'
import { capitalize } from '@/utils/strings'
import DataContainer from '../../common/DataContainer'

const DetailsLogement = ({bien, location}) => (
  <div className="overflow-hidden">
      <h3 className="text-md font-semibold mb-2">Détails de votre logement</h3>
      <div className="w-full bg-primary-100 p-4 rounded-none space-y-4 h-full">
        <div className="flex flex-col gap-4">

          <div className="grid grid-cols-1 sm:grid-cols-[13rem_1fr] items-center gap-2">
            <div className="text-gray-600 whitespace-nowrap">Adresse :</div>
            <div className="pl-2">
              <SingleLineAddress data={bien} apptNumberPrefix={false} />
            </div>
          </div>

          <DataContainer
            label="Type"
            value={capitalize(bien?.type_bien)}
          />
          <DataContainer
            label="Surface"
            value={bien?.surface_carrez ? formatSurface(bien.surface_carrez) : null}
          />
          { bien?.prm_linky && 
            <DataContainer
              label="PRM Linky"
              value={bien?.prm_linky}
            />
          }
          { bien?.numero_compteur_eau &&
            <DataContainer
              label="Compteur d'eau"
              value={bien?.numero_compteur_eau}
            />
          }
          { bien?.numero_compteur_gaz &&
            <DataContainer
              label="Compteur gaz"
              value={bien?.numero_compteur_gaz}
            />
          }

          { bien?.numero_bac_poubelle &&
            <DataContainer
              label="N° Bac Poubelle"
              value={bien?.numero_bac_poubelle} >
            </DataContainer>
          }
          { bien?.numero_badge_poubelle &&
            <DataContainer
              label="N° Badge Poubelle"
              value={bien?.numero_badge_poubelle} >
            </DataContainer>
          }
          { bien?.numero_boitier_fibre &&
            <DataContainer
              label="N° Boîtier Fibre"
              value={bien?.numero_boitier_fibre} >
            </DataContainer>
          }
          { location && <DataContainer
              label="Date d'effet du bail"
              value={formatDate(location?.date_effet_bail)} >
            </DataContainer>
          }

          <DataContainer
            label="Assurance date"
            value={formatDate(bien?.assurance_locataire_date_dernier_releve)} >
              { (bien.mandat_active && !bien?.assurance_locataire_date_dernier_releve) && <span className="text-error">Merci de nous faire parvenir votre justificatif d’assurance</span>}
          </DataContainer>

        </div>

      </div>
  </div>
)

export default DetailsLogement